<script lang="ts">
	import { Button, Container, Modal, SelectCard } from '@Shelly/shelly-design-system/index';
	import type { UpdateModeSubTypes, UpdateModeTypes } from 'src/stores/ui/edit_lists';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showAIModelCommandsModal = false;
	export let onChangeClick = (type: UpdateModeTypes, subType = '' as UpdateModeSubTypes) => {};

	let selectedAICommand: UpdateModeSubTypes = '' as UpdateModeSubTypes;

	export let aiModelCommands = [
		{
			name: 'text_enable_ai_model',
			id: 'enable_ai_model' as UpdateModeSubTypes,
			icon: 'fak fa-solid-sparkles icon-ai-color',
		},
		{
			name: 'text_disable_ai_model',
			id: 'disable_ai_model' as UpdateModeSubTypes,
			icon: 'fak fa-solid-sparkles',
		},
		{
			name: 'manage_ai_notifications',
			id: 'manage_ai_notifications' as UpdateModeSubTypes,
			icon: 'far fa-bells',
		},
	];
</script>

<Modal
	on:close={() => (showAIModelCommandsModal = false)}
	showModal={showAIModelCommandsModal}
	title={$format('ai_model_comands', {
		default: 'Choose an AI Model Command',
	})}
	removeScrollPadding
>
	<Container slot="content" padding="scrollPaddings">
		<!-- DO NOT REMOVE COMMENT: Padding references -->
		<div class="pt-s" />
		{#each aiModelCommands as command, index}
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				type="horizontal"
				variant="radio"
				selected={selectedAICommand === command.id}
				title={$format(command.name)}
				class={`width-full ${index !== aiModelCommands.length - 1 ? 'mb-m' : ''}`}
				icon={command.icon}
				on:click={() => {
					selectedAICommand = command.id;
				}}
			/>
		{/each}

		<!-- DO NOT REMOVE COMMENT: Padding references -->
		<div class="pb-s" />
	</Container>
	<div slot="footer" class="d-flex justify-content-end">
		<Button
			width="m"
			variant="secondary"
			class="mr-s"
			on:click={() => (showAIModelCommandsModal = false)}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			width="m"
			on:click={() => {
				onChangeClick('ai_device_failure', selectedAICommand);
				showAIModelCommandsModal = false;
				selectedAICommand = '';
			}}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
</Modal>
